import { LoyaltyCurrentFtdType, LoyaltyLevelWithRangeType } from '../../types'

export const getCurrentLevel = ({
  currentFtd,
  levels,
  inTop10,
}: {
  currentFtd?: LoyaltyCurrentFtdType
  levels: LoyaltyLevelWithRangeType[]
  inTop10?: boolean
}) => {
  if (inTop10) {
    return levels[levels.length - 1]
  }

  if (currentFtd === undefined) {
    return null
  }

  const currentLevel = levels.find((level) => currentFtd >= level.ftdRange.from && currentFtd <= level.ftdRange.to)

  return currentLevel || null
}
